import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"

import { Container } from "shards-react"

// Promotional Components
import CoursePromotion from "../home/coursePromotions"
import InTheLoop from "../home/inTheLoop"
import OneOnOnePromo from "../home/oneOnOnePromo"
import ProgrammePreview from "../components/programmePreview"

import {
  Button,
  Pane,
  Text,
  majorScale,
  Autocomplete,
  TextInput
} from "evergreen-ui"

// Internal JavaSript libraries
import { getCountry } from "../js/getCountry"

class HomeTemplate extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      country: getCountry(this.props.pageContext.countryCode)
    }
  }

  render() {
    return (
      <Layout countryCode={this.props.pageContext.countryCode}>
        <Seo
          countryCode={this.props.pageContext.countryCode}
          title="Home"
          description=""
        />
        <CoursePromotion countryCode={this.props.pageContext.countryCode} />
        <Container>
          <br />
          <br />
          <ProgrammePreview
            showLabel
            countryCode={this.props.pageContext.countryCode || "JM"}
          />
        </Container>
        <OneOnOnePromo slug={this.state.country.slug} />

        <InTheLoop />
        <br />

        <Container></Container>
      </Layout>
    )
  }
}

export default HomeTemplate
